import ReactHtmlParser from 'react-html-parser';
import { isDevOrLocalEnv } from '../config';

export const retrieveContent = async (urlPath) => {
    const domain = window.origin;
    const cachebuster = Math.round(new Date().getTime() / 1000);
    const url = `${domain}${urlPath}?${cachebuster}`;

    const content = await fetch(url)
        .then((response) => response.json())
        .then(
            (json) =>
                json[':items'].root[':items'].contentfragment.elements.main
                    .value
        )
        .catch(() => undefined);

    return content;
};

export const retrieveContentJSON = (path) => {
    const trpDomain = isDevOrLocalEnv(window.location.host)
        ? 'wwwstage.troweprice.com'
        : window.location.host;
    const cachebuster = Math.round(new Date().getTime() / 1000);
    const url = `https://${trpDomain}${path}?${cachebuster}`;

    return fetch(url)
        .then((response) => response.json())
        .then((json) => json.data.jsonModelByPath.item.json)
        .catch(() => undefined);
};

export const retrieveFragmentContents = async (path) => {
    const trpDomain = isDevOrLocalEnv(window.location.host)
        ? 'wwwstage.troweprice.com'
        : window.location.host;
    const cachebuster = Math.round(new Date().getTime() / 1000);
    const url = `https://${trpDomain}${path}?${cachebuster}`;

    const fragmentData = await fetch(url)
        .then((response) => response.json())
        .then((json) => json[':items'].root[':items'])
        .catch(() => undefined);

    const fragments = [];
    // if there is no fragment data return an empty array
    // because function will not be able to parse the data
    // if fragmentData is undefined.
    if (!fragmentData) return [];
    // content fragments are stored in an object with a key for
    // each one instead of an array. We want to convert them into
    // an array.
    const fragmentDataList = Object.entries(fragmentData);

    fragmentDataList.forEach((fragmentPair) => {
        // We don't need the fragment's data key,
        // only the second item in the pair which
        // is the data's values.
        const fragmentValues = fragmentPair[1];
        try {
            fragments.push({
                id: fragmentValues.id,
                content: ReactHtmlParser(fragmentValues.elements.main.value)
            });
        } catch (_error) {
            // if there is an issue trying to parse the fragment simply
            // don't do anything. Nothing will get pushed into the list
            // of fragments.
        }
    });

    return fragments;
};

export const retrieveAlertAndTickers = async (urlPath) => {
    const domain = window.origin;
    const cachebuster = Math.round(new Date().getTime() / 1000);
    const url = `${domain}${urlPath}?${cachebuster}`;

    let content = {
        tickers: [],
        alertMsg: ''
    };

    try {
        const response = await fetch(url);
        const responseJson = await response.json();
        const { Tickers = {}, AlertMessage = {} } = responseJson[':items'].root[
            ':items'
        ].contentfragment.elements;

        content = {
            tickers: Tickers.value || [],
            alertMsg: AlertMessage.value || ''
        };
    } catch (aemAlertError) {
        /* eslint-disable no-console */
        console.error({ aemAlertError });
        /* eslint-enable no-console */
    }

    return content;
};
